import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/fp/isEmpty';
import { ItemBodyWrapper } from '@instructure/quiz-rce';
import { Text } from '@instructure/ui-text';
import { Alert } from '@instructure/ui-alerts';
import TargetContainer from '../common/TargetContainer';
import t from '@instructure/quiz-i18n/es/format-message';
import Target from './Target';
import { CondensedButton } from '@instructure/ui-buttons';

/**
 ---
category: HotSpot
---

  HotSpot Take component

   ```jsx_example
   function Example (props) {
    const exampleProps = {
      itemBody: 'Which of these players is David Ferrer',
      interactionData: {
        imageUrl: 'https://i.ytimg.com/vi/LgkAebhJ7iE/maxresdefault.jpg'
      },
      userResponse: {
        value: {
          x: 0.3,
          y: 0.3
        }
      }
    }

    return (
      <HotSpotTake {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <TakeStateProvider>
      <Example />
    </TakeStateProvider>
  </SettingsSwitcher>
  ```
**/
var HotSpotTake = /*#__PURE__*/function (_Component) {
  function HotSpotTake(props) {
    var _this;
    _classCallCheck(this, HotSpotTake);
    _this = _callSuper(this, HotSpotTake, [props]);
    _defineProperty(_this, "canAddPoint", function () {
      var _this$state = _this.state,
        selectedCoordinates = _this$state.selectedCoordinates,
        keyboardCoordinates = _this$state.keyboardCoordinates;
      var hotspotsCount = _this.props.interactionData.hotspotsCount;
      var totalSelections = selectedCoordinates.length + (keyboardCoordinates ? 1 : 0);
      return totalSelections < (hotspotsCount || 1);
    });
    _defineProperty(_this, "saveSelectedPoint", function () {
      var _this$state2 = _this.state,
        selectedCoordinates = _this$state2.selectedCoordinates,
        keyboardCoordinates = _this$state2.keyboardCoordinates;
      var _this$props = _this.props,
        multipleHotSpotEnabled = _this$props.multipleHotSpotEnabled,
        hotspotsCount = _this$props.interactionData.hotspotsCount;
      if (!keyboardCoordinates) return;
      var updatedCoordinates = [].concat(_toConsumableArray(selectedCoordinates), [keyboardCoordinates]);
      _this.setState({
        selectedCoordinates: updatedCoordinates,
        keyboardCoordinates: null,
        isSelectingPoint: false
      });
      var response = !multipleHotSpotEnabled && (!hotspotsCount || hotspotsCount === 1) ? keyboardCoordinates : updatedCoordinates;
      _this.props.handleResponseUpdate(response);
    });
    _defineProperty(_this, "handleKeyDown", function (event) {
      var stepSize = 0.05;
      var key = event.key;
      if (!_this.state.focusedContainer) return;
      if (_this.isAnyInputFocused()) return;
      if (key === 's') {
        _this.startSelectingPoint();
      } else if (key === 'd' && _this.state.isSelectingPoint) {
        _this.saveSelectedPoint();
      } else if (key === 'Backspace' || key === 'Delete') {
        _this.handleResetSelections();
      } else if (_this.isArrowKey(key) && _this.state.keyboardCoordinates) {
        event.preventDefault();
        _this.movePosition(key, stepSize);
      }
    });
    _defineProperty(_this, "startSelectingPoint", function () {
      if (!_this.canAddPoint()) return;
      _this.setState({
        keyboardCoordinates: {
          x: 0.5,
          y: 0.5
        },
        isSelectingPoint: true
      });
    });
    _defineProperty(_this, "isArrowKey", function (key) {
      return ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key);
    });
    _defineProperty(_this, "movePosition", function (key, stepSize) {
      var _this$state$keyboardC = _this.state.keyboardCoordinates,
        x = _this$state$keyboardC.x,
        y = _this$state$keyboardC.y;
      var offsets = {
        ArrowUp: {
          x: x,
          y: Math.max(y - stepSize, 0)
        },
        ArrowDown: {
          x: x,
          y: Math.min(y + stepSize, 1)
        },
        ArrowLeft: {
          x: Math.max(x - stepSize, 0),
          y: y
        },
        ArrowRight: {
          x: Math.min(x + stepSize, 1),
          y: y
        }
      };
      _this.setState({
        keyboardCoordinates: offsets[key]
      });
    });
    _defineProperty(_this, "handleSetCoordinates", function (coordinatesArray) {
      if (!_this.canAddPoint()) return;
      var selectedCoordinates = _this.state.selectedCoordinates;
      var _this$props2 = _this.props,
        multipleHotSpotEnabled = _this$props2.multipleHotSpotEnabled,
        hotspotsCount = _this$props2.interactionData.hotspotsCount;
      var x = coordinatesArray[0].x / _this.targetContainer.state.imageWidth;
      var y = coordinatesArray[0].y / _this.targetContainer.state.imageHeight;
      var updatedCoordinates = [].concat(_toConsumableArray(selectedCoordinates), [{
        x: x,
        y: y
      }]);
      _this.setState({
        selectedCoordinates: updatedCoordinates
      });
      var response = !multipleHotSpotEnabled && (!hotspotsCount || hotspotsCount === 1) ? {
        x: x,
        y: y
      } : updatedCoordinates;
      _this.props.handleResponseUpdate(response);
    });
    _defineProperty(_this, "targetContainerRef", function (node) {
      _this.targetContainer = node;
    });
    _defineProperty(_this, "handleResetSelections", function () {
      _this.setState({
        selectedCoordinates: [],
        keyboardCoordinates: null
      });
      _this.props.handleResponseUpdate([]);
    });
    _this.state = {
      selectedCoordinates: [],
      keyboardCoordinates: null,
      isSelectingPoint: false,
      focusedContainer: null
    };
    return _this;
  }
  _inherits(HotSpotTake, _Component);
  return _createClass(HotSpotTake, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$userRespo;
      window.addEventListener('keydown', this.handleKeyDown);
      var value = (_this$props$userRespo = this.props.userResponse) === null || _this$props$userRespo === void 0 ? void 0 : _this$props$userRespo.value;
      if (!isEmpty(value)) {
        this.setState({
          selectedCoordinates: Array.isArray(value) ? value : [value]
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "isAnyInputFocused",
    value: function isAnyInputFocused() {
      var inputs = document.querySelectorAll('input');
      return Array.from(inputs).some(function (input) {
        return input === document.activeElement;
      });
    }
  }, {
    key: "render",
    value:
    // ===========
    //   RENDER
    // ===========

    function render() {
      var _this2 = this;
      var _this$state3 = this.state,
        selectedCoordinates = _this$state3.selectedCoordinates,
        keyboardCoordinates = _this$state3.keyboardCoordinates;
      var hotspots = selectedCoordinates.length > 0 || keyboardCoordinates ? [].concat(_toConsumableArray(selectedCoordinates.map(function (coordinate) {
        return {
          coordinates: [coordinate],
          drawingType: Target
        };
      })), _toConsumableArray(keyboardCoordinates ? [{
        coordinates: [keyboardCoordinates],
        drawingType: Target
      }] : [])) : [{
        coordinates: [{}],
        drawingType: Target
      }];
      return /*#__PURE__*/React.createElement(ItemBodyWrapper, {
        itemBody: this.props.itemBody
      }, /*#__PURE__*/React.createElement(Alert, {
        variant: "info"
      }, /*#__PURE__*/React.createElement(Text, {
        id: "hotspot-oqaat-info"
      }, t.rich("Keyboard controls are available while using the hotspot. Press <0> S </0> to select a point and use the <1>arrow keys</1> to move it, \n               press <2> D </2> to save the position, and press <3> Backspace </3> or <4> Delete </4> to clear all selections. \n               Just make sure the image is focused to use these controls.", [function (_ref) {
        var children = _ref.children;
        return /*#__PURE__*/React.createElement("strong", {
          key: "0"
        }, children);
      }, function (_ref2) {
        var children = _ref2.children;
        return /*#__PURE__*/React.createElement("strong", {
          key: "1"
        }, children);
      }, function (_ref3) {
        var children = _ref3.children;
        return /*#__PURE__*/React.createElement("strong", {
          key: "2"
        }, children);
      }, function (_ref4) {
        var children = _ref4.children;
        return /*#__PURE__*/React.createElement("strong", {
          key: "3"
        }, children);
      }, function (_ref5) {
        var children = _ref5.children;
        return /*#__PURE__*/React.createElement("strong", {
          key: "4"
        }, children);
      }]))), /*#__PURE__*/React.createElement("div", {
        className: "fs-mask"
      }, /*#__PURE__*/React.createElement(TargetContainer, {
        hotspots: hotspots,
        handleSetCoordinates: this.handleSetCoordinates,
        ref: this.targetContainerRef,
        url: this.props.interactionData.imageUrl,
        onFocus: function onFocus() {
          return _this2.setState({
            focusedContainer: _this2.targetContainer
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focusedContainer: null
          });
        }
      })), this.state.selectedCoordinates.length > 0 && /*#__PURE__*/React.createElement(CondensedButton, {
        onClick: this.handleResetSelections,
        margin: "small 0 0 medium",
        "data-automation": "sdk-hotspot-take-clear-selections-button"
      }, t('Clear my selection')));
    }
  }]);
}(Component);
_defineProperty(HotSpotTake, "propTypes", {
  handleResponseUpdate: PropTypes.func.isRequired,
  interactionData: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    hotspotsCount: PropTypes.number
  }).isRequired,
  itemBody: PropTypes.string.isRequired,
  userResponse: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })), PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })]).isRequired
  }),
  scoringData: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    })).isRequired
  }),
  multipleHotSpotEnabled: PropTypes.bool
});
export { HotSpotTake as default };